import { brandFor, resolveBrandName } from './brands';
/**
 * The settings of the brand this deployment runs — resolved once, when the
 * module loads, from the runtime config the portal container writes before the
 * bundle runs (see ./brands). Every consumer reads this one object.
 */
export const defaultBrandConfig = brandFor(resolveBrandName());
